'use client';

import Icon from '@/components/ui/AppIcon';

const features = [
  {
    icon: 'ClockIcon',
    title: 'Real-time Tracking',
    description: 'Monitor your shipment at every destination stop point',
  },
  {
    icon: 'ShieldCheckIcon',
    title: 'Secure Handling',
    description: 'Insurance coverage and secure facilities at all stops',
  },
  {
    icon: 'BellAlertIcon',
    title: 'Status Alerts',
    description: 'Instant notifications when shipment reaches each stop',
  },
  {
    icon: 'DocumentCheckIcon',
    title: 'Customs Support',
    description: 'Expert assistance with documentation and clearance',
  },
];

const benefits = [
  'Track shipment through multiple destination stops',
  'Country-specific tracking codes',
  'Email & SMS notifications at each stop',
  'Estimated arrival time for each location',
  'Photo proof of delivery',
  'Signature confirmation',
  '24/7 customer support',
  'Insurance up to $10,000',
];

export default function ServiceSelector() {
  return (
    <div className="space-y-6">
      {/* Why Choose Us */}
      <div className="bg-card rounded-xl p-6 shadow-card border border-border">
        <h3 className="text-xl font-heading font-semibold text-foreground mb-4">
          Why Choose Dream Work Shipping?
        </h3>
        <div className="space-y-4">
          {features.map((feature, index) => (
            <div key={index} className="flex gap-3">
              <div className="shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={feature.icon as any} size={20} className="text-primary" />
              </div>
              <div>
                <h4 className="font-semibold text-foreground mb-1">{feature.title}</h4>
                <p className="text-sm text-muted-foreground">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* What's Included */}
      <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl p-6 border border-primary/20">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          What's Included
        </h3>
        <ul className="space-y-2">
          {benefits.map((benefit, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-foreground">
              <Icon name="CheckCircleIcon" size={16} className="text-success mt-0.5 shrink-0" />
              <span>{benefit}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Help Section */}
      <div className="bg-card rounded-xl p-6 shadow-card border border-border">
        <div className="flex items-center gap-3 mb-3">
          <Icon name="QuestionMarkCircleIcon" size={24} className="text-primary" />
          <h3 className="text-lg font-heading font-semibold text-foreground">
            Need Help?
          </h3>
        </div>
        <p className="text-sm text-muted-foreground mb-4">
          Our logistics experts are available 24/7 to assist you with your shipment.
        </p>
        <div className="space-y-2">
          <a
            href="tel:+18001234567"
            className="flex items-center gap-2 text-sm text-primary hover:text-primary/80 transition-colors"
          >
            <Icon name="PhoneIcon" size={16} />
            <span>+1 800 123 4567</span>
          </a>
          <a
            href="mailto:support@dreamworkshipping.com"
            className="flex items-center gap-2 text-sm text-primary hover:text-primary/80 transition-colors"
          >
            <Icon name="EnvelopeIcon" size={16} />
            <span>support@dreamworkshipping.com</span>
          </a>
        </div>
      </div>
    </div>
  );
}